import React from "react";
import { Link } from "react-router-dom";

const HowToUse = () => (
  <div style={{ maxWidth: 700, margin: "40px auto", padding: 20, fontFamily: "Nunito, sans-serif", lineHeight: 1.6 }}>
    <h1 style={{ color: "#1e293b", textAlign: "center" }}>🚀 How to use Eluvent</h1>
    <p style={{ textAlign: "center", color: "#64748b" }}>Learn, test, and get help – all in one place. No sign‑up needed!</p>

    <div style={{ background: "#fef9c3", padding: 16, borderRadius: 12, margin: "20px 0" }}>
      <h3>🤖 AI answers according to your syllabus</h3>
      <p>Eluvent knows the <strong>CBSE and ICSE syllabus</strong> for Physics, Chemistry, Biology, Mathematics, English, History, Geography and more. Every answer follows your textbooks and exam pattern.</p>
    </div>

    <div style={{ background: "#dbeafe", padding: 16, borderRadius: 12, margin: "20px 0" }}>
      <h3>👨‍🏫 A teacher steps in whenever you need it</h3>
      <p>If a question is very difficult, you’re stuck, or the AI thinks a <strong>Subject Matter Expert</strong> would help better — it will offer to connect you with a real teacher. You can also request a teacher anytime by clicking the “Teacher” button.</p>
    </div>

    <div style={{ background: "#dcfce7", padding: 16, borderRadius: 12, margin: "20px 0" }}>
      <h3>📝 Take a test and discover your level</h3>
      <p>Click <strong>“Topic Test”</strong> on the chat page. Pick your board, subject, and chapter. Eluvent generates <strong>brand‑new questions</strong> just for you. After the test, your score is saved and you can see your <strong>strong & weak areas</strong> in “My Progress”.</p>
      <p>All kids are welcome – whether you want to practise, challenge yourself, or just see where you stand.</p>
    </div>

    <div style={{ background: "#f3e8ff", padding: 16, borderRadius: 12, margin: "20px 0" }}>
      <h3>🎒 Here’s how kids usually learn with Eluvent</h3>
      <ol style={{ paddingLeft: 20 }}>
        <li><strong>Ask a doubt</strong> – type, speak, or snap a photo.</li>
        <li><strong>Take a test</strong> – see how well you really know the topic.</li>
        <li><strong>Check Progress</strong> – find weak areas and improve them.</li>
        <li><strong>Get teacher help</strong> – whenever the AI suggests, or whenever you feel like it.</li>
      </ol>
    </div>

    <p style={{ textAlign: "center", marginTop: 30 }}>
      <Link to="/" style={{ padding: "10px 20px", background: "#fca311", color: "white", borderRadius: 30, textDecoration: "none", fontWeight: 700 }}>
        ← Back to Chat
      </Link>
    </p>
  </div>
);

export default HowToUse;